import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
import { trackPixelEvent } from './MetaPixel';
const includes = ['Guía de Autocuración Energética de 48 páginas.', 'Documento de orientación “Empezá acá”.', 'Planificador de Autocuidado.', 'Calendario Lunar.', 'Limpieza Energética del Hogar.', 'Diccionario de Cristales.', 'Ritual de Protección.', '50 Afirmaciones.', 'Respirá en 5 Minutos.', 'Diario de Bienestar de 30 Días.'];
export function ClosingBlock() {
  return <section id="cierre" className="w-full scroll-mt-20 bg-plum px-5 py-14 sm:py-24" data-id="element-60" data-mp="1rz9566aubl2g">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-61" data-mp="1rwv7dporzur7">
        <span className="mb-5 inline-block rounded-full border border-gold/50 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-gold" data-id="element-62" data-mp="1d4bav7w4sliq">
          Aura Viva 2026
        </span>

        <h2 className="font-serif-display text-2xl font-bold leading-tight text-cream sm:text-4xl" data-id="element-63" data-mp="3slzfmq95yy6f">
          Tu momento para volver a vos puede comenzar hoy
        </h2>

        <p className="mt-4 text-sm leading-relaxed text-cream/80 sm:text-base" data-id="element-64" data-mp="3iuv27uz4zldp">
          Dejá de guardar consejos, rituales y prácticas aisladas sin saber cuál utilizar.
        </p>
        <p className="mt-3 text-sm leading-relaxed text-cream/80 sm:text-base" data-id="element-65" data-mp="fcbgzcevlfse">
          Con Aura Viva 2026 tenés una guía visual y ocho herramientas complementarias organizadas
          para ayudarte a reconocer qué necesitás y comenzar con una acción concreta.
        </p>

        <div className="mt-8 flex flex-col items-center" data-id="element-66" data-mp="2l6bfo7x2rioa">
          <span className="font-serif-display text-[56px] font-bold leading-none text-gold sm:text-7xl" data-id="element-67" data-mp="2l8xmg5c55u5g">
            USD 12
          </span>
          <p className="mt-3 text-sm font-medium text-cream/85" data-id="element-68" data-mp="wn8asmlitv9f">Pago único · Sin suscripción</p>
        </div>

        <motion.a href={CHECKOUT_URL} onClick={() => trackPixelEvent('InitiateCheckout')} whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} transition={{
        type: 'spring',
        stiffness: 400,
        damping: 22
      }} className="mt-7 flex min-h-[58px] w-full max-w-md items-center justify-center rounded-[10px] bg-aura px-4 py-4 text-center text-[13px] font-extrabold tracking-tight text-white shadow-lg shadow-plum/40 ring-1 ring-gold/40 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold sm:text-lg sm:tracking-normal" data-id="element-69" data-mp="rox2whesdutu">
          QUIERO COMENZAR AHORA POR USD 12
        </motion.a>
        <p className="mt-3 text-xs text-cream/75" data-id="element-70" data-mp="1yb9dbx0mydi9">
          Acceso digital inmediato · Compra protegida por 7 días
        </p>

        <ul className="mt-9 grid w-full max-w-md gap-2.5 text-left" data-id="element-71" data-mp="1te0t7qvxfzed">
          {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-72" data-mp="20wgv2gxnh4k8">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-lavender/15 text-lavender" data-id="element-73" data-mp="25us3qoc7l90v">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-74" data-mp="2anboq6d876fp" />
              </span>
              <span className="text-sm leading-relaxed text-card" data-id="element-75" data-mp="2fkv5bcxebvat">{item}</span>
            </li>)}
        </ul>

        <p className="mt-7 rounded-full border border-gold/40 px-5 py-2 text-sm font-medium text-gold" data-id="element-76" data-mp="1i08v9sneplwb">
          10 archivos digitales · 97 páginas · Acceso de por vida
        </p>

        <div className="mt-7 w-full max-w-md rounded-xl bg-cream/10 px-4 py-3" data-id="element-77" data-mp="1rur2h7s17zkv">
          <p className="text-xs font-semibold leading-relaxed text-cream sm:text-sm" data-id="element-78" data-mp="1wvwz3gotc6zo">
            🌎 Disponible para todos los países de Latinoamérica.
          </p>
          <p className="mt-1.5 text-xs leading-relaxed text-cream/75 sm:text-[13px]" data-id="element-79" data-mp="389sl99e4xg0e">
            Antes de cerrar la compra, la página convierte automáticamente el precio a tu moneda
            local.
          </p>
        </div>

        <p className="mt-9 font-serif-display text-lg font-bold leading-snug text-cream sm:text-xl" data-id="element-80" data-mp="31vd9dtonw5jv">
          No necesitás cambiarlo todo de una vez. Solo necesitás{' '}
          <span className="text-gold" data-id="element-81" data-mp="3au71b6r1s7r3">elegir un primer paso</span>.
        </p>
      </motion.div>
    </section>;
}